import { useEffect } from 'react';

function useRefetchOnFocus<T extends { refetch: () => void }>(query: T, disabled?: boolean) {
  const { refetch } = query;

  useEffect(() => {
    if (!disabled) {
      const callback = () => refetch();
      window.addEventListener('focus', callback);
      return () => window.removeEventListener('focus', callback);
    }
    return undefined;
  }, [disabled, refetch]);

  return query;
}

export default useRefetchOnFocus;
